/*
 * Create an integer in range [min...max]  (max is included)
 *  The return value is not cryptographically secure!
 *  @param min: number
 *  @param max: number
 *  @return float  in range [min...max]
 */
export function getRandomInt(min: number, max: number): number {
  const minVal = Math.ceil(min);
  const maxVal = Math.floor(max);

  return Math.floor(Math.random() * (maxVal - minVal + 1)) + minVal;
}

/*
 * Create a float in range [min...[max   (max is excluded!)
 *  The return value is not cryptographically secure!
 *  @param min: number
 *  @param max: number first value behind the returned range.
 *  @return float  in range [min...[max
 */
export function getRandomFloat(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
